module.exports = __webpack_public_path__ + "static/media/icon-rel-exame.917cd47b.png";